import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import {
  assign_interview_to_bucket_list_data_action,
  create_shortlisting_candidate_by_hm_action,
  get_bucket_list_data_by_id_action,
  get_bucketlist_candidate_data_action,
  get_loggedin_user_meta_data_action,
  get_shortlisted_candidates_by_hm_action,
  hm_delete_shortlisted_candidate_by_id_action,
  update_shortlisted_candidate_by_hm_data_action,
} from "../../../redux/_actions";
function useViewBucketList(props) {
  const [loadingBucketList, setLoadingBucketList] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingCandidateList, setLoadingCandidateList] = useState(false);
  const [shortlistCandidates, setShortlistCandidates] = useState({});
  const [bucketListData, setBucketListData] = useState([]);
  const [candidatesData, setCandidatesData] = useState([]);
  const [bucketListId, setBucketListId] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [utmToken, setUtmToken] = useState(null);
  const [utmId, setUtmId] = useState(null);
  const [userToken, setUserToken] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  const { bucketListByIdData } = useSelector(
    (state) => state.get_bucket_list_data_by_id_reducer
  );

  const { bucketCandidatesData } = useSelector(
    (state) => state.get_bucketlist_candidate_data_reducer
  );

  const { loggedInMetaData } = useSelector(
    (state) => state.get_loggedin_user_meta_data_reducer
  );

  const { allShortlistedCandidateData } = useSelector(
    (state) => state.get_shortlisted_candidates_by_hm_reducer
  );

  useEffect(() => {
    getUserToken();
    let url = new URL(window.location.href);
    let utmId = url.searchParams.get("utmid");
    let utmToken = url.searchParams.get("utm_token");
    setUtmId(utmId);

    setUtmToken(utmToken);
  }, []);

  useEffect(() => {
    const bucketId = params && params?.id;
    if (bucketId) {
      setBucketListId(bucketId);
      getBucketListData(bucketId);
      getBucketListCandiatesData(bucketId);
      callShortListedCandidatesApi();
    }
  }, []);

  //get bucket id
  useEffect(() => {
    const id = params?.id;
    if (id) {
      callApi(id);
    }
    if (userToken) callUserApi();
  }, [userToken]);

  useEffect(() => {
    if (bucketListByIdData?.data) {
      setBucketListData(bucketListByIdData?.data);
    }
  }, [bucketListByIdData]);

  useEffect(() => {
    if (bucketCandidatesData?.data) {
      let data =
        bucketCandidatesData?.data && bucketCandidatesData.data?.results;
      setCandidatesData(data);
    }
  }, [bucketCandidatesData]);

  useEffect(() => {
    if (allShortlistedCandidateData?.data) {
      let data =
        allShortlistedCandidateData?.data &&
        allShortlistedCandidateData.data?.results;
      setShortlistCandidates(data);
    }
  }, [allShortlistedCandidateData]);

  useEffect(() => {
    if (loggedInMetaData?.data) {
      setUserDetails(loggedInMetaData?.data);
    }
  }, [loggedInMetaData]);

  const callUserApi = async (id) => {
    setLoadingBucketList(true);
    //call user api
    await dispatch(get_loggedin_user_meta_data_action());
    setLoadingBucketList(false);
  };
  const getUserToken = async (id) => {
    const token = await localStorage.getItem("jigsawUser");
    setUserToken(JSON.parse(token));
  };

  const callApi = async (id) => {
    setLoadingBucketList(true);
    // call bucket api
    await dispatch(get_bucket_list_data_by_id_action(id));
    setLoadingBucketList(false);
  };

  const getBucketListData = async (id) => {
    setLoadingBucketList(true);
    await dispatch(get_bucket_list_data_by_id_action(id));
    setLoadingBucketList(false);
  };

  const getBucketListCandiatesData = async (id) => {
    setLoadingCandidateList(true);
    await dispatch(get_bucketlist_candidate_data_action(id));
    setLoadingCandidateList(false);
  };

  const countTime = (data) => {
    let total_time = 0;
    Array.isArray(data) &&
      data.forEach((element) => {
        element?.questions &&
          element.questions.forEach((item) => {
            total_time = item?.time_to_answer + total_time;
          });
      });
    return total_time;
  };
  const countQuestions = (data) => {
    let total_question = 0;
    Array.isArray(data) &&
      data.forEach((element) => {
        total_question =
          element?.questions && element.questions.length + total_question;
      });
    return total_question;
  };

  // const onViewCandidatesClick = (interviewKit) => {
  //   navigate(`/shortlisted-candidates-assessments/${interviewKit}`);
  // };

  const onClickEditAssessment = (id) => {
    navigate(`/create-assessment/${id}`);
  };

  const onViewCandidateProfileClick = (id) => {
    if (utmId && utmToken && !userDetails) {
      navigate(`/hm-reset-password/${utmId}/${utmToken}`, {
        state: {
          navigateRoute: `/shortlisted-candidates-assessments/}`,
        },
      });
    } else {
      if (id) navigate(`/view-candidate-profile/${id}`, { state: id });
    }
  };

  const checkExitingAssessment = (item) => {
    if (item) {
      let itemIndex =
        Array.isArray(
          bucketListData && bucketListData.assigned_assessments_details
        ) &&
        bucketListData &&
        bucketListData.assigned_assessments_details.findIndex(
          (obj) => obj?.id === item
        );
      return itemIndex >= 0;
    }
  };

  const onClickAddAssementToBucket = async (kitId) => {
    const bucketId = params && params?.id;

    if (bucketId) {
      const data = {
        bucket_list: bucketId,
        interview_kit: kitId,
      };
      const res = await dispatch(
        assign_interview_to_bucket_list_data_action(data)
      );

      if (res && res.msg) {
        getBucketListData(bucketId);
      }
    }
  };
  const handleBackClick = () => {
    navigate(-1);
  };

  const tabChangesHandler = () => {
    if (bucketListId) {
      getBucketListCandiatesData(bucketListId);
      getBucketListData(bucketListId);
    }
  };

  const onViewcandidateDetail = async (interviewKit) => {
    navigate(`/view-bucket-detail/${interviewKit}`);
  };

  const onClickShortlist = async (candidateBucketListId) => {
    if (utmId && utmToken && !userDetails) {
      navigate(`/hm-reset-password/${utmId}/${utmToken}`, {
        state: {
          navigateRoute: `/shortlisted-candidates-assessments/}`,
        },
      });
    } else {
      const kitId = params?.id;
      const data = {
        bucket_list_candidate: candidateBucketListId,
        is_favourite: true,
      };
      await dispatch(create_shortlisting_candidate_by_hm_action(data));
      await dispatch(get_bucketlist_candidate_data_action(kitId));
      await dispatch(get_shortlisted_candidates_by_hm_action());
    }
  };

  const onClickUnShortlist = async (id) => {
    if (utmId && utmToken && !userDetails) {
      navigate(`/hm-reset-password/${utmId}/${utmToken}`, {
        state: {
          navigateRoute: `/shortlisted-candidates-assessments/}`,
        },
      });
    } else {
      await dispatch(hm_delete_shortlisted_candidate_by_id_action(id));
      const kitId = params?.id;
      if (kitId) {
        const data = {
          is_favourite: false,
        };
        await dispatch(
          update_shortlisted_candidate_by_hm_data_action(data, id)
        );
        await dispatch(get_bucketlist_candidate_data_action(kitId));
        await dispatch(get_shortlisted_candidates_by_hm_action());
      }
    }
  };

  const callShortListedCandidatesApi = async () => {
    setLoading(true);
    await dispatch(get_shortlisted_candidates_by_hm_action());
    setLoading(false);
  };

  const onPublicProfileClick = (id) => {
    navigate(`/view-candidate-profile/${id}`);
  };

  const onViewAssessmentClick = (interview_kit, applicantId) => {
    navigate(
      `/view-assessment-video?interviewKit=${interview_kit}&applicant=${applicantId}`
    );
  };

  const onDeleteFavouriteClick = async (favId) => {
    await dispatch(hm_delete_shortlisted_candidate_by_id_action(favId));
    await dispatch(get_shortlisted_candidates_by_hm_action());
  };

  return {
    loadingBucketList,
    loadingCandidateList,
    candidatesData,
    bucketListData,
    shortlistCandidates,
    countTime,
    onDeleteFavouriteClick,
    countQuestions,
    onClickEditAssessment,
    onViewCandidateProfileClick,
    onClickAddAssementToBucket,
    checkExitingAssessment,
    handleBackClick,
    tabChangesHandler,
    onViewcandidateDetail,
    onClickShortlist,
    onClickUnShortlist,
    onViewAssessmentClick,
    onPublicProfileClick,
  };
}
export default useViewBucketList;
